import React from 'react'
import { connect } from 'react-redux'
import { REDUCER, submit } from 'ducks/registration'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'

import { sprintf } from 'sprintf-js'
import l8n, { e } from 'l8n'
import XRegExp from 'xregexp'
import linkit from 'scripts/linkit';
import { siteUrl } from 'scripts/siteUrl';
import { AuthPolicy } from 'components/CleanComponents/AuthPolicy/index';

const FormItem = Form.Item;
const mapStateToProps = (state) => ({
  formSubmitted: state.app.submitForms[REDUCER],
  googleIdToken: state.registration.googleIdToken,
  email: state.registration.email,
  password: state.registration.password,
  name: state.registration.name,
});

@connect(mapStateToProps)
@Form.create({
  mapPropsToFields(props) {
    return {
      display_name: Form.createFormField({ ...props.name, value: props.name }),
    }
  }
})
class ProfileForm extends React.Component {
  onSubmit = (formSubmitted) => event => {
    event.preventDefault();
    const { form, dispatch, googleIdToken, email, password } = this.props;
    if (! formSubmitted) {
      form.validateFields((error, values) => {
        if (!error) {
          dispatch(submit({
            ...values,
            googleIdToken,
            email,
            password,
          }));
        }
      });
    }
  };

  checkDisplayName = (rule, value, callback) => {
    const regexp = XRegExp('\\pL{3,}');
    if (regexp.test(value)) {
      callback();
    } else {
      callback(e(l8n.p_incorrect_value));
    }
  };

  render() {
    const { form, formSubmitted } = this.props;
    return (
      <Form className="auth-form" hideRequiredMark onSubmit={this.onSubmit(formSubmitted)}>
        <FormItem hasFeedback label={l8n.p_partner_name}>
          {form.getFieldDecorator('display_name', {
            validateFirst: true,
            rules: [
              { required: true, message: e(l8n.p_required) },
              { min: 3, message: e(sprintf(l8n.p_string_too_short, 3)) },
              { max: 100, message: e(sprintf(l8n.p_string_too_long, 100)) },
              { validator: this.checkDisplayName },
            ],
          })(
            <Input
              prefix={<Icon type="user"  style={{ fontSize: '14px', color: 'rgba(0,0,0,.25)' }} />}
              placeholder={l8n.p_partnerNamePlaceholder}
              className="ant-input-lg"
              data-qa-id="registration-name-input"
            />
          )}
        </FormItem>
        <FormItem hasFeedback label={l8n.p_web_site}>
          {form.getFieldDecorator('site_url', {
            rules: [
              { pattern: /^(https?:\/\/)?([a-zа-я0-9-_]+\.)*[a-zа-я0-9][a-zа-я0-9-_]+\.[a-zа-я]{2,11}?/ui, message: e(l8n.p_domain_wrong) },
              { min: 4, message: e(sprintf(l8n.p_string_too_short, 4)) },
              { max: 100, message: e(sprintf(l8n.p_string_too_long, 100)) },
            ],
          })(
            <Input
              prefix={<Icon type="link"  style={{ fontSize: '14px', color: 'rgba(0,0,0,.25)' }} />}
              placeholder={'mysite.com'}
              className="ant-input-lg"
              data-qa-id="registration-site-input"
            />
          )}
        </FormItem>
        <FormItem hasFeedback label={l8n.p_phone}>
          {form.getFieldDecorator('phone', {
            rules: [
              { pattern: /^[\d\s\)\(\-\+)]{5,20}$/i, message: e(l8n.p_phone_symbols) },
              { min: 5, message: e(sprintf(l8n.p_string_too_short, 5)) },
              { max: 20, message: e(sprintf(l8n.p_string_too_long, 20)) },
            ],
          })(
            <Input
              prefix={<Icon type="phone"  style={{ fontSize: '14px', color: 'rgba(0,0,0,.25)' }} />}
              placeholder={'+1 234 567 89 00'}
              className="ant-input-lg"
              data-qa-id="registration-phone-input"
            />
          )}
        </FormItem>
        <div className="form-actions">
          <Button type="primary" htmlType="submit" className="auth-form-button" data-qa-id="registration-submit-button" loading={formSubmitted}>
            {l8n.p_request_submit}
          </Button>
          {l8n.locale !== 'ru' && (
            <div style={{marginTop: 12}}>
              {linkit(l8n['signup.gdpr'], [{
                href: `${siteUrl()}/files/privacy_policy.pdf`,
                target: '_blank',
                className: 'text-primary utils__link--underlined'
              }])}
            </div>
          )}
        </div>
        <AuthPolicy/>
      </Form>
    )
  }
}

export default ProfileForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/RegistrationForm/ProfileForm/index.js